import { Controller } from "@hotwired/stimulus";
import debounce from "debounce";

export default class extends Controller {
  static targets = ["input", "message", "loading"];

  static values = {
    url: String,
    frame: String,
  };

  initialize() {
    this.search = debounce(this.search.bind(this), 300);
    this.onFrameLoad = () => this.loadingTarget.classList.add("hidden");
  }

  connect() {
    this.inputTarget.classList.remove("valid", "error");
    this.frame = document.getElementById(this.frameValue);
    if (this.frame) this.frame.addEventListener("turbo:frame-load", this.onFrameLoad);
  }

  disconnect() {
    if (this.frame) this.frame.removeEventListener("turbo:frame-load", this.onFrameLoad);
  }

  search() {
    this.inputTarget.classList.remove("valid", "error");
    const term = this.inputTarget.value.trim();

    if (term.length === 0) {
      this.messageTarget.classList.add("hidden");
      this.loadingTarget.classList.add("hidden");
      if (this.frame) this.frame.style.display = "";
      this.setFrameSrc("");
    } else if (term.length < 3) {
      this.messageTarget.textContent = "Enter at least 3 characters to search";
      this.messageTarget.classList.remove("hidden");
      this.loadingTarget.classList.add("hidden");
      if (this.frame) this.frame.style.display = "none";
    } else {
      this.messageTarget.classList.add("hidden");
      this.loadingTarget.classList.remove("hidden");
      if (this.frame) this.frame.style.display = "";
      this.setFrameSrc(term);
    }
  }

  setFrameSrc(searchTerm) {
    if (!this.frame) return;
    const url = new URL(this.urlValue, window.location.origin);
    if (searchTerm) url.searchParams.set("search", searchTerm);
    this.frame.src = url.toString();
  }
}
